module.exports = __webpack_public_path__ + "img/lock.a43d0ec8.svg";